import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {OrderedItem} from "../interface/ordered-item";
import {OrderwiseWorkflow} from "../interface/orderwise-workflow";
import {BloomsightService} from "../../bloomsight.service";
import {GlobalService} from "../../services/global.service";

@Component({
	selector: 'fb-order-item-process-overview',
	templateUrl: './order-item-process-overview.component.html',
	styleUrls: ['./order-item-process-overview.component.scss']
})
export class OrderItemProcessOverviewComponent implements OnChanges {

	@Input()
	public product: OrderedItem = {} as OrderedItem;
	@Input()
	public orderId: number = 0;

	@Input()
	public orderItemId: number = 0;

	@Input()
	public workflow: OrderwiseWorkflow = {} as OrderwiseWorkflow;

	public showProcess: boolean = false;

	@Output()
	public emitMoreUpdatesToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor(
		private _bloomsight: BloomsightService,
		private _userData: GlobalService,
	) {
	}

	private _scrollToMedia(id: number): void {
		const media:HTMLElement | null = document.getElementById(id + '-feedback');
		if (!media) return;

		media.scrollIntoView({
			behavior: 'smooth',
			block: "start",
			inline: "start"
		});

	}

	ngOnChanges(changes: SimpleChanges) {
		if(this.workflow.workflowId) {
			this.workflow.steps.forEach(step => {
				let completedSubProcess = 0;
				step.subProcesses.forEach(sub => {
					if(sub.subProcessStatus === "COMPLETED") {
						completedSubProcess += 1;
					}
					else if(sub.subProcessStatus === "IN_PROGRESS") {
						completedSubProcess += 0.4;
					}
				});
				step.stepProgress =  (completedSubProcess / step.subProcesses.length) * 100;
			});

			if(this.orderItemId && this.product.id === this.orderItemId) {
				setTimeout(() => {
					this.onViewProcessUpdates('feedback');

					setTimeout(()  => {
						this._scrollToMedia(this.orderItemId);

					}, 100)
				}, 100);
			}
		}
	}

	public onViewProcessUpdates(view: string): void {
		if(view === 'feedback') {
			this.showProcess = true;
		}
		else {
			this.showProcess = !this.showProcess;
		}
		this.emitMoreUpdatesToggle.emit(this.showProcess);

		if(this.showProcess) {
			this._bloomsight.trackDataEvent(
				'679b76338f02e72fbfce155b',
				[
					{orderId: this.orderId},
					{email: this._userData.customerProfileData.tenant.email},
					{sku: this.product.customization.fabricProductPreview? this.product.customization.fabricProductPreview.product.sku : this.product.customization.finishedProductPreview?.product.sku},
					{orderType: this.product.orderType},
					{all: this.orderId + '-' + this._userData.customerProfileData.tenant.email + '-' + (this.product.customization.fabricProductPreview? this.product.customization.fabricProductPreview.product.sku : this.product.customization.finishedProductPreview?.product.sku) + '-' + this.product.orderType}
				],
				'Order Details- See all updates button'
			)
		}
	}
}
